// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { ref } from "vue";
import { NumberFound } from "libphonenumber-js/max";
import PhoneHelper from "../helpers/phoneHelper";
import oidcManager from "../authentication/oidcManager";

/* global Office */

export default function () {
  const suggestedPhoneNumbersMobile = ref([]);
  const suggestedPhoneNumbersOther = ref([]);

  /**
   * Searches the mobile phones
   * @param {string} queryString - the search string
   * @param {Function} callback - callback function
   */
  async function searchMobilePhones(queryString: string, callback: (suggestions: any) => []) {
    searchPhones(suggestedPhoneNumbersMobile.value, queryString, callback);
  }

  /**
   * Searches the other phones
   * @param {string} queryString - the search string
   * @param {Function} callback - callback function
   */
  async function searchOtherPhones(queryString: string, callback: (suggestions: any) => []) {
    searchPhones(suggestedPhoneNumbersOther.value, queryString, callback);
  }

  /**
   * Searches the phones
   * @param {string[]} phoneNumbers - the phone numbers
   * @param {string} queryString - the search string
   * @param {Function} callback - callback function
   */
  function searchPhones(phoneNumbers: string[], queryString: string, callback: (suggestions: any) => []) {
    if (queryString) {
      const results = phoneNumbers
        .filter((p: any) => p.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
        .map((p: any) => {
          return {
            value: p,
          };
        });
      callback(results);
    } else {
      const results = phoneNumbers.map((p: any) => {
        return {
          value: p,
        };
      });
      callback(results);
    }
  }

  /**
   * Gets phone numbers from body
   */
  async function getPhoneNumbersFromBody(phoneModel: { mobile: string; phone: string }, assignNumber: boolean) {
    await Office.context.mailbox.item?.body.getAsync(Office.CoercionType.Text, (asyncResult) => {
      getPhoneNumbersFromBodyCallback(asyncResult, phoneModel, assignNumber);
    });
  }

  /**
   * Gets phone numbers from body callback
   */
  async function getPhoneNumbersFromBodyCallback(
    asyncResult: Office.AsyncResult<string>,
    phoneModel: { mobile: string; phone: string },
    assignNumber: boolean
  ) {
    if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
      let results: NumberFound[] = PhoneHelper.getPhoneNumbersFromText(asyncResult.value);

      // Filter out the user's phone number
      if (oidcManager.userProfile.phone_number) {
        const userPhoneNumber = PhoneHelper.parseFromString(oidcManager.userProfile.phone_number);
        if (userPhoneNumber) {
          results = results.filter((p) => p.number.number !== userPhoneNumber!.number);
        }
      }

      suggestedPhoneNumbersMobile.value = results
        .filter((p) => PhoneHelper.isPhoneNumberMobile(p.number))
        .map((r) => r.number.number.toString()) as any;
      suggestedPhoneNumbersOther.value = results
        .filter((p) => !PhoneHelper.isPhoneNumberMobile(p.number))
        .map((r) => r.number.number.toString()) as any;

      if (assignNumber) {
        if (suggestedPhoneNumbersMobile.value && suggestedPhoneNumbersMobile.value.length > 0) {
          phoneModel.mobile = suggestedPhoneNumbersMobile.value[0];
        }

        if (suggestedPhoneNumbersOther.value && suggestedPhoneNumbersOther.value.length > 0) {
          phoneModel.phone = suggestedPhoneNumbersOther.value[0];
        }
      }
    }
  }

  return {
    suggestedPhoneNumbersMobile,
    suggestedPhoneNumbersOther,
    getPhoneNumbersFromBody,
    searchPhones,
    searchOtherPhones,
    searchMobilePhones,
  };
}
